/* Free-gift cleanup (site-wide).
   A free gift line carries the hidden property _gwp_machine (the machine's
   product id), set by cpap-pdp-bundle.js. When the customer removes the machine
   (or lowers its quantity), this removes the surplus gift lines, so the cart
   never shows a "free" gift at full price. The checkout rule in
   cdw-shopify-functions (eofy-gift-pack-validation) still blocks such a cart. */
(function () {
  'use strict';
  var busy = false;

  function sectionIds() {
    return Array.prototype.map
      .call(document.querySelectorAll('cart-items-component[data-section-id]'), function (el) {
        return el.getAttribute('data-section-id');
      })
      .filter(Boolean);
  }

  function check() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var machineQty = {};
        cart.items.forEach(function (i) {
          machineQty[i.product_id] = (machineQty[i.product_id] || 0) + i.quantity;
        });
        var budget = {};
        var changes = [];
        cart.items.forEach(function (i) {
          var m = i.properties && i.properties._gwp_machine;
          if (!m) return;
          // One gift per machine PER GIFT GROUP (_gwp_group), e.g. toothbrush + shaver.
          var k = m + '|' + (i.properties._gwp_group || '');
          if (!(k in budget)) budget[k] = machineQty[m] || 0;
          var keep = Math.min(i.quantity, budget[k]);
          budget[k] -= keep;
          if (keep < i.quantity) changes.push({ id: i.key, quantity: keep });
        });
        if (!changes.length) return null;
        var ids = sectionIds();
        return changes.reduce(function (p, ch, n) {
          return p.then(function () {
            var last = n === changes.length - 1;
            var body = { id: ch.id, quantity: ch.quantity };
            if (last && ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(body)
            }).then(function (r) { return r.json(); });
          });
        }, Promise.resolve()).then(function (res) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: res, data: { source: 'gwp-cleanup', sections: res && res.sections } }
          }));
          // The /cart page (sections/cpap-cart.liquid) draws its own lines and does not
          // re-render on cart:update, so reload it to show the gift removed.
          if (window.location.pathname === '/cart') window.location.reload();
        });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  document.addEventListener('cart:update', function (e) {
    var src = e.detail && e.detail.data && e.detail.data.source;
    if (src === 'gwp-cleanup') return;
    setTimeout(check, 50);
  });
  if (window.location.pathname === '/cart') check();
})();
